export class FeatureToggleNotifications {
  constructor(featureToggleClient) {
    this.FEATURE_TOGGLE_NAME = 'notifications';
    this.featureToogleClient = featureToggleClient;
  }

  async getNotification() {
    return this.featureToogleClient(this.FEATURE_TOGGLE_NAME);
  }
}
